function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDetails(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      textIndent: 0,
      textAlign: "start",
      lineHeight: "normal",
      textTransform: "none",
      blockProgression: "tb",
      InkscapeFontSpecification: "Bitstream Vera Sans"
    },
    d: "M 5 5 L 5 6 L 5 26 L 5 27 L 6 27 L 12.5625 27 L 15.28125 29.71875 L 16 30.40625 L 16.71875 29.71875 L 19.4375 27 L 26 27 L 27 27 L 27 26 L 27 6 L 27 5 L 26 5 L 6 5 L 5 5 z M 7 7 L 25 7 L 25 25 L 19 25 L 18.59375 25 L 18.28125 25.28125 L 16 27.5625 L 13.71875 25.28125 L 13.40625 25 L 13 25 L 7 25 L 7 7 z M 10 11 L 10 13 L 12 13 L 12 11 L 10 11 z M 14 11 L 14 13 L 22 13 L 22 11 L 14 11 z M 10 15 L 10 17 L 12 17 L 12 15 L 10 15 z M 14 15 L 14 17 L 22 17 L 22 15 L 14 15 z M 10 19 L 10 21 L 12 21 L 12 19 L 10 19 z M 14 19 L 14 21 L 22 21 L 22 19 L 14 19 z",
    color: "#000",
    overflow: "visible",
    fontFamily: "Bitstream Vera Sans"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetails);
export default __webpack_public_path__ + "static/media/Details.29198d4954f7acecd662768301f14b28.svg";
export { ForwardRef as ReactComponent };